import { useMemo } from 'react'

import type { Widget } from '@pages/IntroducingBroker/DashboardPoC/types'
import type { WidgetVisibilityContext } from '@pages/IntroducingBroker/DashboardPoC/widgetRegistry'
import { widgetRegistry } from '@pages/IntroducingBroker/DashboardPoC/widgetRegistry'

export function useVisibleWidgets(
  widgets: Widget[],
  visibility: WidgetVisibilityContext,
  isMobile: boolean
): Widget[] {
  return useMemo(() => {
    if (!visibility.isVisibilityReady) {
      return []
    }

    return widgets.filter((widget) => {
      if (isMobile && !widget.mobileLayout) {
        return false
      }

      if (!isMobile && !widget.layout) {
        return false
      }

      return widgetRegistry[widget.type].isVisible(visibility)
    })
  }, [visibility, widgets, isMobile])
}
